"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = _interopRequireDefault(require("./styles"));
var _ReaderNavigation = _interopRequireDefault(require("../ReaderNavigation"));
var _ReferencePopover = _interopRequireDefault(require("../ReferencePopover"));
var _StylePopover = _interopRequireDefault(require("../StylePopover"));
var _Theme = require("../../contexts/Theme");
var _PdfReader = _interopRequireDefault(require("../../services/PdfReader"));
var _Copy = _interopRequireDefault(require("../../services/Copy"));
var _Auth = require("../../contexts/Auth");
var _Copy2 = require("../../contexts/Copy");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var TopBarMobile = _ref => {
  var {
    pdf
  } = _ref;
  var [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  var [openReference, setOpenReference] = (0, _react.useState)(false);
  var [openStyle, setOpenStyle] = (0, _react.useState)(false);
  var {
    copyValue,
    setCopyValue
  } = (0, _Copy2.useCopy)();
  var open = Boolean(anchorEl);
  var menuRef = (0, _react.useRef)();
  var {
    theme
  } = (0, _Theme.useTheme)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var classes = (0, _styles.default)();
  var handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = () => {
    setAnchorEl(null);
  };
  function onStylePopover() {
    setAnchorEl();
    setOpenStyle(true);
  }
  var handleReferencePopover = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      var {
        applicationToken,
        sessionToken,
        userId,
        uuid
      } = auth;
      if (!pdf) return;
      var totalLength = yield _PdfReader.default.getAllContentFromPdf(pdf);
      var newCopyValue = yield _Copy.default.getPercentageCharsCopied(applicationToken, sessionToken, userId, uuid, totalLength.length);
      setCopyValue(parseInt(newCopyValue));
      setOpenReference(true);
      setAnchorEl(null);
    });
    return function handleReferencePopover() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper,
    style: {
      backgroundColor: theme.reader.backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: () => window.history.back()
  }, /*#__PURE__*/_react.default.createElement(_icons.NavigateBefore, {
    style: {
      color: theme.reader.color
    }
  })), /*#__PURE__*/_react.default.createElement(_ReaderNavigation.default, {
    pdf: pdf
  }), /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleClick,
    disabled: !pdf,
    ref: menuRef
  }, /*#__PURE__*/_react.default.createElement(_icons.MoreVert, {
    style: {
      color: theme.reader.color
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    anchorEl: anchorEl,
    open: open,
    getContentAnchorEl: null,
    onClose: handleClose,
    className: classes.menu,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: classes.mi
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    style: {
      textTransform: 'none'
    },
    className: classes.btn,
    onClick: onStylePopover
  }, /*#__PURE__*/_react.default.createElement(_icons.FormatSize, {
    className: classes.icon
  }), "Estilo")), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: classes.mi
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    style: {
      textTransform: 'none'
    },
    className: classes.btn,
    onClick: handleReferencePopover
  }, /*#__PURE__*/_react.default.createElement(_icons.FormatQuote, {
    className: classes.icon
  }), "Refer\xEAncia"))), /*#__PURE__*/_react.default.createElement(_ReferencePopover.default, {
    copyValue: copyValue,
    openReference: openReference,
    setOpenReference: setOpenReference
  }), /*#__PURE__*/_react.default.createElement(_StylePopover.default, {
    open: openStyle,
    setOpen: setOpenStyle,
    anchorEl: menuRef.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }));
};
TopBarMobile.propTypes = {
  pdf: _propTypes.default.object
};
var _default = exports.default = TopBarMobile;